import styled from '@emotion/styled'
import {theme} from '../../../../core/theme'

export const AddonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[3]};
`

export const SubTabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  border-bottom: 0.5px solid #bcbef6;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bcbef6;
    border-radius: ${theme.radii.md};
  }
`

export const SubTabButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[1.5]};
  font-family: ${theme.fonts.openSans};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${({isActive}) =>
    isActive ? theme.fontWeights.bold : theme.fontWeights.regular};
  color: ${({isActive}) =>
    isActive ? theme.colors.text.primary : theme.colors.text.primary};
  background: none;
  border: none;
  border-bottom: 2px solid
    ${({isActive}) => (isActive ? '#566fc3' : 'transparent')};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: ${({isActive}) =>
    isActive
      ? 'linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%)'
      : 'none'};
  padding: ${theme.space[3]} ${theme.space[4]} ${theme.space[2]};
  bottom: ${({isActive}) => (isActive ? '1px' : '0')};
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  svg {
    width: 12px;
    height: 12px;
  }
`

export const BillingToggleRow = styled.div`
  display: flex;
  align-items: center;
`

// auto-fit matches the Software tab's CardsGrid (see CatalogGrid.styles.js
// for why) — only bites here when a group has fewer add-ons than the row
// has tracks.
export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: ${theme.space[3]};
`
